import { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface IDialogFooter {
    children: ReactNode
}

function DialogFooter(props:IDialogFooter) {
    return (
        <Modal.Footer {...props}>
            {props.children}
        </Modal.Footer>
    );
}

export default DialogFooter;
